import {
	AEMContent,
	FieldWrapper,
	Heading,
	Label,
	Modal,
	TextLink,
} from '@mlc/web-ui-toolkit';
import React, { useEffect, useRef } from 'react';
import EpiTestIds from '../Account/Account.elements';
import * as Styled from './styled';

type Props = {
	name: string;
	isInvalid: boolean;
	isAccepted: (accepted: boolean) => void;
	mode?: string;
};

const TermsAndConditions: React.FC<Props> = props => {
	const errorMessage = 'Review and accept the terms and conditions to proceed';
	const [checked, setChecked] = React.useState(false);
	const [isOpen, setIsOpen] = React.useState(false);
	const linkRef = useRef<any>();

	useEffect(() => {
		props.isAccepted(checked);
	}, [checked]);

	const onClose = () => {
		setIsOpen(false);
		linkRef.current.focus();
	};

	return (
		<React.Fragment>
			<FieldWrapper
				error={errorMessage}
				isInvalid={props.isInvalid}
				name="terms-and-conditions"
				style={{ paddingTop: '40px' }}
			>
				<Styled.Wrapper>
					<Styled.Checkbox
						id={props.name + '_termsAndConditions'}
						value={checked}
						checked={checked}
						onChange={() => setChecked(!checked)}
						data-id={EpiTestIds.tAndCs}
						mode={props.mode}
						data-analytics-capture-value
					/>
					<label htmlFor={props.name + '_termsAndConditions'}>
						I agree with the
						<TextLink
							el="button"
							onClick={() => setIsOpen(true)}
							ref={linkRef}
							type="button"
						>
							<Label padding={1}>Terms and Conditions</Label>
						</TextLink>
						of using the Client Data Exchange service.
					</label>
				</Styled.Wrapper>
			</FieldWrapper>
			<Modal
				title="Terms and Conditions"
				isOpen={isOpen}
				onRequestClose={() => onClose()}
				height={700}
				align="left"
				data-analytics-group="dialog"
				data-id={EpiTestIds.tAndCsModal}
			>
				<Heading el="h2" fontSize="little" fontWeight="medium" marginBottom={6}>
					Client Data Exchange - Terms and conditions of use
				</Heading>
				<AEMContent path="/secure/_content/Adviser/epi/terms-and-conditions" />
			</Modal>
		</React.Fragment>
	);
};

export default TermsAndConditions;
